import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { List,Icon,Form,Tabs,Button,Table,Modal,Row,Col,Steps,message } from 'antd';
import { Link } from 'react-router-dom';
import { fetchApplicationList } from '../../actions/employee-actions';
import DynamicForm from "../../components/frame/DynamicForm";
// import DynamicButton from "../../components/frame/DynamicButton";
import applicationCenterService from '../../services/Employee/application-center-service';
import approvalCenter from "../../services/Employee/approval-center-service";



const TabPane = Tabs.TabPane;
class ApplicationCenter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentModalStatus: false,
			currentIndex: null,
			currentData: {},
			stepsCurrent:0,
			currentDataStatus: "unload",
			filters: {
				tabIndex: "1"
			},
			data: [],
			dataStatus: "unload",
			steps: []
		}
	}
	componentWillMount() {
		this.props.fetchApplicationList();
	}
	HomeLink = () => {
		let result = []; 
		if (this.props.access.employeeApplicationCenter.apply_overtime_value) {
			result.push({
		    name: '加班申请',
        enname: 'Overtime Application',
		    icon: 'clock-circle-o',
		    path: '/employee/apply-overtime'
		  })
		}
		if (this.props.access.employeeApplicationCenter.apply_relax_value) {
			result.push({
		    name: '调休申请',
        enname: 'Use Overtime Application',
		    icon: 'sync',
		    path: '/employee/apply-break-down'
		  })
		}
		if (this.props.access.employeeApplicationCenter.apply_leave_value) {
			result.push({
		    name: '请假申请',
        enname: 'Apply for Leave',
		    icon: 'logout',
		    path: '/employee/apply-leave'
		  })
		}
		if (this.props.access.employeeApplicationCenter.apply_annual_leave_value) {
			result.push({
		    name: '年假申请',
        enname: 'Apply for Annual Leave',
		    icon: 'file-add',
		    path: '/employee/apply-annual-leave'
		  })
		}
		if (this.props.access.employeeApplicationCenter.apply_travel_value) {
			result.push({
		    name: '出差申请',
        enname: 'Apply for Business Trip',
		    icon: 'export',
		    path: '/employee/apply-business'
		  })
		}
		if (this.props.access.employeeApplicationCenter.apply_goout_value) {
			result.push({
		    name: '外出申请',
        enname: 'Apply for Work Offsite',
		    icon: 'car',
		    path: '/employee/apply-go-out'
	 		})
		}
		return result;
	}

 	rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({selectedIDs: ids});
		}
	}
	fetchApplicationList = pagination => {
		console.log(pagination);
		this.props.fetchApplicationList({page: pagination.current});
	}
	closeCurrentModal = () => {
		this.setState({
			currentModalStatus: false
		});
	}

	crrentDetail = (index,record) => {
		// console.log(record)
		this.setState({currentModalStatus: true});
		// update
		this.setState({
			currentData: this.props.employee.applicationData[index],
			currentDataStatus: "loaded"
		});

		approvalCenter.fetchApprovalFlowLog({document_id:record.id}, res => {
			this.setState({
				stepsCurrent:res.data.currentStep,
				steps:res.data.steps
			})
		})
		this.setState({currentIndex: index});

	}
	UndoApproval = record =>{
		let posts = {
				id:record.id,
				approval_type_str:record.approval_type
			};
		applicationCenterService.UndoApproval(posts, res => {
			if (res.data.Success) {
				message.success("撤销成功", 4);
				this.props.fetchApplicationList();
			}else{
				message.error("撤销失败", 4);
			}
		}, err => {});
	}
	UrgeApproval = record =>{
		let posts = {
				id:record.id,
				approval_type_str:record.approval_type
			};
		applicationCenterService.UrgeApproval(posts, res => {
			if (res.data.Success) {
				message.success("催审成功", 4);
			}else{
				message.error("催审失败", 4);	
			}
		}, err => {});
	}
	formColumn = () => [{
			label: "申请类型",
			key: "approval_type",
			type: "textex",
			span: 24
		}, {
			label: "申请选择",
			key: "apply_type",
			type: "textex",
			span: 24
		}, {
			label: "开始日期",
			key: "start_date",
			type: "textex",
			span: 12
		}, {
			label: "开始时间",
			key: "start_time",
			type: "textex",
			span: 12
		}, {
			label: "结束日期",
			key: "end_date",
			type: "textex",
			span: 12
		}, {
			label: "结束时间",
			key: "end_time",
			type: "textex",
			span: 12
		}, {
			label: "时长",
			key: ["hours_str","time_type"],
			type: "textArray",
			span: 12
		}, {
			label: "申请时间",
			key: "created_time_str",
			type: "textex",
			span: 12
		}, {
			label: "原因",
			key: "remark",
			type: "textex",
			span: 24
		}
	]
	render() {
		const columns = [{
					title: <div><div>序号</div><div>NO.</div></div>,
					key: "row_index",
					dataIndex: "row_index",
					className: 'table-global-head-tiny'
				}, {
					title: <div><div>申请类型</div><div>Apply Type</div></div>,
					key: "apply_type",
					dataIndex: "apply_type",
					className: 'table-global-head-small'
				}, {
					title: <div><div>提交时间</div><div>Submit Time</div></div>,
					key: "created_time_str",
					dataIndex: "created_time_str",
					className: 'table-global-head'
				}, {
					title: <div><div>申请内容</div><div>Apply Content</div></div>,
					key: "apply_content",
					dataIndex: "apply_content",
					className: 'table-global-head'
				},{
					title: <div><div>时长</div><div>Apply Duration</div></div>,
					key: "hours_str",
					dataIndex: "hours_str",
					className: 'table-global-head'
				}, {
					title: <div><div>审批状态</div><div>Status</div></div>,
					key: "approval_status_str",
					dataIndex: "approval_status_str",
					className: 'table-global-head-small'
				}, {
					title: <div><div>操作</div><div>Action</div></div>,
					key: "action",
					dataIndex: "action",
					className: 'table-global-head',
					render: (text, record, index) => (
						<span>
              {this.props.access.employeeApplicationCenter.list_value && <Button icon="edit" size="small" className="row-action-btn" onClick={this.crrentDetail.bind(this, index,record)}>查看 View</Button>}
              {this.props.access.employeeApplicationCenter.revert_value && <Button icon="edit" size="small" className="row-action-btn" disabled={record.approval_status=='2'} onClick={this.UndoApproval.bind(this, record)}>撤销 Undo</Button>}
              {this.props.access.employeeApplicationCenter.urge_value && <Button icon="edit" size="small" className="row-action-btn" onClick={this.UrgeApproval.bind(this, record)}>催审 Urge</Button>}
            </span>
					)
				}]
		return (
			<div className="app-module-item">
				<Tabs defaultActiveKey="1" animated={false}>
				    <TabPane tab="发起申请 Initiate Apply" key="1">
						<div className="Attendanceholiday">考勤假期 Attendance holiday</div>
						<List
		                  grid={{ gutter: 16, column: 6 }}
		                  dataSource={this.HomeLink()}
		                  renderItem={item => (
		                    <List.Item> 
		                      <Link to={item.path}>
		                        <div className="mobileMenu">
		                          <div className="mobileMenuIcon"><Icon type={item.icon}/></div>
		                          <div className="mobileMenuName">{item.name}<br/>{item.enname}</div>
		                        </div>
		                      </Link>
		                    </List.Item>
		                  )}
		                />
				    </TabPane>
				    <TabPane tab="申请记录 Apply Record" key="2">
						<Table columns={columns} 
							dataSource={this.props.employee.applicationData}
							pagination={{total: this.props.employee.applicationTotalPage,
								defaultCurrent: 1,
								pageSize: this.props.employee.applicationPageSize,
								current: this.props.employee.applicationPage}}
							scroll={{x: 1010}}
							onChange={this.fetchApplicationList.bind(this)}
							rowKey={record => record.id} 
							// rowSelection={this.rowSelection}
						 />
				    </TabPane>
				    
				  </Tabs>
				  <Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="申请查看"
					destroyOnClose={true}
					onCancel={this.closeCurrentModal}
					onOk={this.closeCurrentModal}
					>
					<Row>
						<Col span={16}>
							<div style={{borderRight: "1px solid gray", paddingRight: "0px"}}>
								<DynamicForm column={this.formColumn}
									form={this.props.form}
									loadStatus={this.state.currentDataStatus}
									dataSource={this.state.currentData}
								/>
							</div>
						</Col>
						<Col span={8}>
							<div style={{paddingLeft: "20px"}}>
								<Steps direction="vertical" size="small" current={this.state.stepsCurrent}>
									{this.state.steps&&this.state.steps.map((step, index) => (
										<Steps.Step title={step.approval_user_name}
										 key={index}
										 description={step.description} />
									))}
								</Steps>
							</div>
						</Col>
					</Row>
				</Modal>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee
	}
}

const mapDispatchToProps = {
	fetchApplicationList
}

ApplicationCenter = Form.create()(ApplicationCenter);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ApplicationCenter));


// WEBPACK FOOTER //
// ./src/routes/Employee/ApplicationCenterEn.js